export type ColorTypes =
  | 'white'
  | 'confirm'
  | 'gray'
  | 'light'
  | 'superlight'
  | 'darkgray'
  | 'dark'
  | 'action'
  | 'bad'
  | 'know'
  | 'calm'
  | 'allgood'
  | 'purple'
  | 'heart'
  | 'mutedlightpurple'
  | 'neutral'
  | 'outline'
  | 'mutedPurple'
  | 'ashPurple'
  | 'blush'
  | Purple;

export const colors: { [key in ColorTypes]: string } = {
  white: '#fff',
  confirm: 'rgb(147,208,167)',
  gray: '#dbdbdb',
  superlight: '#F9F9F9',
  light: '#eaeaea',
  darkgray: '#888',
  dark: '#333333',
  action: '#5ba4e5',
  bad: '#db505d',
  know: '#fff4b8',
  calm: '#c48a91',
  allgood: '#93d0a7',
  purple: '#9E84AB',
  blush: '#dea38a',
  heart: '#D5716B',
  outline: 'rgb(185,185,185)',
  neutral: '#eaeaea',
  mutedlightpurple: '#E9EAEE',
  mutedPurple: '#BAB8C4',
  ashPurple: '#847DA3',
  purple_10: '#fbfafc',
  purple_20: '#f2f0f7',
  purple_30: '#e3e1ef',
  purple_40: '#d0cbe5',
  purple_50: '#b8b2d6',
  purple_60: '#9f97c3',
  purple_70: '#857dab',
  purple_80: '#6b638e',
  purple_90: '#514a6e',
  purple_90a: '#514a6ecc'
};

type Purple =
  | 'purple_10'
  | 'purple_20'
  | 'purple_30'
  | 'purple_40'
  | 'purple_50'
  | 'purple_60'
  | 'purple_70'
  | 'purple_80'
  | 'purple_90'
  | 'purple_90a';

export const getColorByType = (type?: ColorTypes): string => {
  if (!type) {
    return colors.action;
  }
  return Object.keys(colors).reduce((acc, curr) => {
    if (curr === type) {
      return colors[curr];
    } else {
      return acc;
    }
  }, colors.action);
};
